import React, { useState } from "react";
import { Box, Flex, Modal, ModalContent, Spinner, useDisclosure } from "@chakra-ui/react";
import { Button, DirectionalButton, IconButton, type ButtonProps } from "ui/button";
import { trackDemoEmbedClosed, trackDemoEmbedOpened } from "components/event-tracking";
import { LegacyCloseIcon } from "ui/icons";

type Props = {
  demoId?: string;
  demoName?: string;
  buttonType?: "default" | "directional";
} & Omit<ButtonProps, "onClick" | "leftIcon" | "rightIcon">;

export function NavatticDemoModal({
  demoId = process.env.NEXT_PUBLIC_NAVATTIC_GATED,
  demoName = "Gated master",
  buttonType = "default",
  children,
  ...buttonProps
}: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState<boolean>(false);

  const openModalClicked = () => {
    setLoading(true);
    trackDemoEmbedOpened(demoId!, demoName);
    onOpen();
  };

  const closeModalClicked = () => {
    trackDemoEmbedClosed(demoId!, demoName);
    onClose();
  };

  return (
    <Box position="relative">
      {buttonType === "default" ? (
        <Button onClick={openModalClicked} {...buttonProps}>
          {children}
        </Button>
      ) : (
        <DirectionalButton onClick={openModalClicked} {...buttonProps}>
          {children}
        </DirectionalButton>
      )}

      <Modal size="full" isOpen={isOpen} onClose={onClose}>
        <ModalContent
          padding="small"
          containerProps={{
            zIndex: "navatticDemo",
          }}
        >
          <IconButton
            pos="absolute"
            right="6px"
            top="6px"
            icon={LegacyCloseIcon}
            aria-label="Close demo"
            onClick={closeModalClicked}
          />

          <Flex flexGrow={1} alignItems="center" justifyContent="center">
            {loading && (
              <Spinner
                size="xl"
                thickness="6px"
                emptyColor="brand.backgroundSecondary.light"
                color="new.green.900"
                speed="0.65s"
                pos="absolute"
                zIndex={1}
              />
            )}

            <Box
              as="iframe"
              borderRadius="smallest"
              src={`https://capture.navattic.com/${demoId}`}
              allow="fullscreen"
              w="100%"
              alignSelf="stretch"
              objectFit="contain"
              onLoad={() => {
                setLoading(false);
              }}
            />
          </Flex>
        </ModalContent>
      </Modal>
    </Box>
  );
}
